export default __webpack_public_path__ + "static/media/deliveryVisuals@3x.6eba28d5.png";